import { useState } from "react";
import { CalendarDays } from "lucide-react";
import { formatDMY } from "@/lib/date";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDateObj = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
const toDateStr = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

const calendarClassNames = {
  day_today: "ring-2 ring-[#5C2D91] ring-offset-1 rounded-md font-bold text-[#5C2D91]",
  day_selected: "bg-[#5C2D91] text-white hover:bg-[#4A2475] hover:text-white focus:bg-[#5C2D91] focus:text-white rounded-md",
  day: "h-9 w-9 p-0 font-normal rounded-md text-[#0F172A] transition-colors hover:bg-[#5C2D91]/10 aria-selected:opacity-100",
  caption_label: "text-sm font-semibold text-[#0F172A]",
  head_cell: "text-[#64748B] rounded-md w-9 font-medium text-[0.75rem]",
};

export const DateField = ({ value, onChange, testid }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="flex w-full items-center justify-between gap-2 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-[#0F172A] outline-none transition-colors hover:border-[#5C2D91] focus:border-[#5C2D91] focus:ring-1 focus:ring-[#5C2D91]"
        >
          <span className={value ? "" : "text-[#94a3b8]"} data-testid={`${testid}-value`}>{value ? formatDMY(value) : "dd/mm/yyyy"}</span>
          <CalendarDays className="h-4 w-4 shrink-0 text-[#5C2D91]" aria-hidden="true" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto rounded-xl border-slate-200 p-0 shadow-lg">
        <Calendar
          mode="single"
          selected={toDateObj(value)}
          defaultMonth={toDateObj(value)}
          onSelect={(d) => { if (d) { onChange(toDateStr(d)); setOpen(false); } }}
          initialFocus
          classNames={calendarClassNames}
        />
        {value && (
          <div className="border-t border-slate-100 px-3 py-2 text-right">
            <button type="button" onClick={() => { onChange(""); setOpen(false); }} className="text-xs font-semibold text-[#5C2D91] hover:underline" data-testid={`${testid}-clear`}>Clear</button>
          </div>
        )}
      </PopoverContent>
    </Popover>
  );
};
